exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3CGF-ad5tjZzAR46HvXubs{display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);

// exports
exports.locals = {
	"groupFacepile": "_3CGF-ad5tjZzAR46HvXubs"
};